module.exports = __webpack_public_path__ + "static/media/Senorita.9ba16188.mp3";